const objFunc = () => {
  return {
    loans: [],
    showRateChangeModal: false,
    refinanceDenied: false,

    activeApplication: {
      isInProgress: false,
      applicationNumber: undefined,
      applicationDate: undefined,
      returnUrl: undefined
    },
    expressApplicationUrl: undefined,
    reapplyInfo: {},
    declinedTlxeApplications: [],
    showCreditLimitModal: false,
    hasMoreOpenLoans: false,
    hasMoreClosedLoans: false,
    hasMoreDeclinedResults: false,
    pendingRefiInfo: {},
    pendingReapplyInfo: {}
  }
}

export default objFunc()

export const defaultObj = objFunc()
